import { ExternalAuthError, SocialLoginProvider } from '@account/account-portal/external-auth'
import { FrontendName } from '@account/account-portal/lib'
import { User } from '@account/account-portal/types'
import { Permission } from '@account/consents-shared-lib'
import { createGlassHttp } from '@crystal/glass-bridge'

import { ExternalAuthPayload, KmcAuthResponse } from './types'

export function useApiClient() {
  const { get, post } = createGlassHttp({
    clientTag: `${FrontendName} - ExternalAuthPage`,
  })

  async function socialLogin(body: ExternalAuthPayload, provider: SocialLoginProvider): Promise<User> {
    try {
      const loginResponse = await post<User, ExternalAuthPayload>('/api/account/social-login', body)
      const permissions = await get<Permission[]>('/api/permissions/get-permissions')
      return {
        ...loginResponse,
        session: {
          isNewUser: loginResponse.isNewUser,
          isPersistent: loginResponse.isPersistent,
          socialProvider: loginResponse.isSocialLogin ? provider : undefined,
          reAuthAfter: loginResponse.expirationTimestamp,
          hasPermissionsAccepted: permissions && permissions.length > 0,
        },
      }
    } catch (e) {
      throw new ExternalAuthError('Failed to authenticate with social login code', {
        details: e as Record<string, unknown>,
      })
    }
  }

  async function kmcAuth(code: string) {
    try {
      return await get<KmcAuthResponse>(`/api/account/kmc-data/${code}`)
    } catch (e) {
      throw new ExternalAuthError('Failed to authenticate with KMC code', {
        details: e as Record<string, unknown>,
      })
    }
  }

  return {
    socialLogin,
    kmcAuth,
  }
}
